import React from "react";
import { useNavigate } from "react-router-dom";

function Get_Help({ backState = null, className = "" }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backState) {
      navigate("/Support", { state: backState });
    } else {
      navigate("/Support");
    }
  };

  return (
      <button
        onClick={handleBack}
        className={`
        inline-flex items-center gap-.5 sm:gap-2
        px-1 py-1.5 sm:px-7 sm:py-2.5
        bg-gray-200
        text-white text-xs sm:text-sm font-semibold
        rounded-lg sm:rounded-xl
        shadow-sm hover:shadow-md
        hover:scale-105 active:scale-150
        transition-all duration-200
        ${className}
      `}
        
      >
        <img src="/support.png" className="w-5 h-5 object-contain" />
        <div className="text-left leading-tight">
          <p className="text-sm font-medium text-gray-800">
            Get Support
          </p>
        </div>
      </button>
  );
}

export default Get_Help;